import { BlockAPI } from '@editorjs/editorjs';
import { ActivityBlockConfig } from '..';
import Alternative, { AlternativeStatus } from '../model/alternative';
import Quiz from '../model/quiz';
import { mountAlternativeId } from '../utils/alternative';

export default class QuizService {
  constructor(
    private readonly quiz: Quiz,
    private readonly block: BlockAPI,
    private readonly config?: ActivityBlockConfig,
  ) {}

  private correctAnswer(alternative: Alternative): AlternativeStatus {
    this.config?.callbacks.onCorrectAnswer?.(alternative.toJson());
    const item = this.block.holder.querySelector(
      `#${mountAlternativeId(alternative.getId())}`,
    );

    if (item) item.classList.add('alternative-correct');

    return 'correct';
  }

  private resetClassnames() {
    this.block.holder.querySelectorAll('.alternative-item').forEach(item => {
      item.classList.remove('alternative-correct', 'alternative-incorrect');
    });
  }

  private incorrectAnswer(alternative: Alternative): AlternativeStatus {
    this.config?.callbacks.onIncorrectAnswer?.(alternative.toJson());
    const item = this.block.holder.querySelector(
      `#${mountAlternativeId(alternative.getId())}`,
    );
    if (item) item.classList.add('alternative-incorrect');

    return 'incorrect';
  }
  public shouldBlockRetries() {
    return !this.config?.allowRetries && this.quiz.isDone();
  }

  private updateQuiz(alternative: Alternative, status: AlternativeStatus) {
    this.quiz.updateAlternativeStatus(alternative.getId(), status);
    this.quiz.setDone(true);
    return this.quiz.toJson();
  }

  private async validateAnswer(
    alternative: Alternative,
  ): Promise<AlternativeStatus> {
    const answer = await this.config?.callbacks.getAnswer?.(this.quiz.toJson());
    if (answer?.id === alternative.getId())
      return this.correctAnswer(alternative);
    else return this.incorrectAnswer(alternative);
  }
  private blockRetries() {
    if (!this.config?.allowRetries) {
      this.block.holder
        .querySelectorAll('.alternative-radio')
        .forEach(radio => {
          radio.setAttribute('disabled', 'disabled');
        });
    }
  }

  onAnswer = async (alternative: Alternative, persist: boolean = false) => {
    this.resetClassnames();
    this.config?.callbacks.onCheckAnswer?.(
      alternative.toJson(),
      this.quiz.toJson(),
    );
    const result = await this.validateAnswer(alternative);
    this.blockRetries();
    if (persist) return this.updateQuiz(alternative, result);
  };
}
